import { opaccAjaxPlugin, opaccLogPlugin } from '../opacc.static.js';
import { compareMessages } from '../messages/opacc.messages.js';

/** @module compare */

/**
 * Basisklasse für die Funktionalität des Artikelvergleichs
 */
export class OpaccCompare {
	constructor() {
		this.contentContainer = document.querySelector('.content');
		this.requestData = {};

		let compareTable = document.querySelector('#compareTable');
		let compareTopbar = document.querySelector('.compare-topbar');
		if (compareTable && compareTable.offsetTop === 0) {
			compareTable.style.marginTop = `${compareTopbar.offsetHeight}px`;
		}
	}

	/**
	 *
	 *
	 * @param {*} error
	 */
	asyncErrorHandler(error) {
		// Custom Error Handling
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
		this.hookAfterAsyncErrorHandler(error);
	}

	// ---------------------------------

	/**
	 *
	 *
	 * @param {*} item
	 */
	// eslint-disable-next-line no-unused-vars
	hookBeforeSendAjaxRequest(item){}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns  {*}
	 */
	hookBeforeReturnPrepareDataSubmission(item, data){return data;}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeRefreshContent(data) {return data;}

	/**
	 *
	 *
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterRefreshContent(data){}

	/**
	 *
	 *
	 * @param {*} error
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterAsyncErrorHandler(error){}
}

/**
 * Funktionalität für den Vergleich-Button
 *
 * @extends {OpaccCompare}
 */
export class OpaccCompareButton extends OpaccCompare {
	constructor() {
		super();
		this.countContainer = document.querySelectorAll('.opc-compare-info .compare-count');
		this.showHintText = false;
		this.messages = compareMessages;
		this.compareView = document.querySelector('.compare-wrapper');
		this.attachEventListener();
	}

	/**
	 * Methode initalisiert die Eventlistner.
	 */
	attachEventListener() {
		if (this.contentContainer) {
			this.contentContainer.addEventListener('click', e => {
				// Artikel zur Vergleichsansicht hinzufügen/entfernen
				let button = e.target.closest('.opc-compare-button');
				if(button && !button.disabled) {
					this.showHintText = (button.dataset.opShowhinttext === 'true');
					this.sendAjaxRequest(button);
				}
				// Vergleichsansicht-Gruppe ein/ausblenden
				let groupTitle = e.target.closest('.compare-group-title');
				if(groupTitle) {
					let group = groupTitle.nextElementSibling;
					if(group.className == 'compare-group') {
						if(group.style.display == 'none') {
							group.style.display = 'block';
						} else {
							group.style.display = 'none';
						}
					}
				}
			});
		}
	}

	/**
	 * Methode sendet asynchronen Ajax Request.
	 * @param {*} item
	 */
	sendAjaxRequest(item) {
		this.requestData = {
			Type: 'Compare',
			CompareType: item.dataset.opComparetype,
			Id: item.dataset.opItemid
		};

		this.hookBeforeSendAjaxRequest(item);
        let url = opaccAjaxPlugin.setAsyncUrl();
		opaccAjaxPlugin.fetchAsynPostForm(url, this.hookBeforeReturnPrepareDataSubmission(item, this.requestData), this.refreshContent.bind(this), this.asyncErrorHandler.bind(this), true);
	}

	/**
	 * Methode aktualisiert den Content.
	 * @param {*} response
	 */
	refreshContent(response) {
		response = this.hookBeforeRefreshContent(response);

		if (response.success || this.showHintText) {
			// CSS-Klassen aktualisieren
			if (this.contentContainer) {
				let items = this.contentContainer.querySelectorAll(`.opc-compare-button[data-op-itemid="${this.requestData.Id}"]`);
				Array.from(items).forEach((item, index) => {
					if (response.dataAsJson.comparestatus === 'a') {
						item.classList.add('is-active');
					} else {
						if (response.dataAsJson.success) {
							item.classList.remove('is-active');
							this.removeCompareItem(item);
						} else {
							if (this.showHintText) {
								let htmlObj = document.createElement('div');
								htmlObj.innerHTML = response.dataAsJson.htmlcode;
								let hintText = htmlObj.querySelector('[data-op-message="showhinttext"]');
								if (hintText && hintText.innerHTML) {
									if (index === 0) {
										opaccLogPlugin.showMessage(this.messages.messageHint, hintText.innerHTML);
									}
								}
							}
						}
					}
				});
			}
			// Vergleichszaehler aktualisieren
			if (this.countContainer.length > 0) {
				let counter = this.countContainer[0].textContent;
				if (response.dataAsJson.comparestatus === 'a') {
					counter++;
				} else if (response.dataAsJson.comparestatus === 'p' && response.dataAsJson.success) {
					counter--;
				}
				if (response.success) {
					Array.from(this.countContainer).forEach(item => {
						if (counter === 0) {
							item.textContent = '';
						} else {
							item.textContent = counter;
						}
					});
				}
			}
		}

		this.hookAfterRefreshContent(response);
	}

	/**
	 * Methode entfernt Vergleichsitems.
	 * @param {*} item
	 */
	removeCompareItem(item) {
		let compareItem = item.closest('.compare-item');
		if(compareItem && this.contentContainer) {
			let items = this.contentContainer.querySelectorAll(`.${compareItem.className.replace(' ', '.')}`);
			Array.from(items).forEach(item => {
				let parent = item.parentNode;
				parent.removeChild(item);
				if(parent.querySelectorAll('.compare-item').length == 0) {
					window.location.reload();
				}
			});
		}
	}
}

/**
 * Funktionalität für Kategorienwechsel in der Vergleichsansicht
 *
 * @extends {OpaccCompare}
 */
export class OpaccCompareSelect extends OpaccCompare {
	constructor() {
		super();
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.contentContainer) {
			this.contentContainer.addEventListener('change', e => {
				// Kategorie der Vergleichsansicht wechseln
				let select = e.target.closest('.opc-compare-selection > select[name="ArtCompareType"]');
				if(select) {
					this.sendAjaxRequest(select);
				}
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	sendAjaxRequest(item) {
		this.requestData = {
			ArtCompareType: item.options[item.selectedIndex].value,
			Target: item.dataset.opTargetdiv
		};

		this.hookBeforeSendAjaxRequest(item);
		opaccAjaxPlugin.fetchAsynPostForm(item.dataset.opPosturl, this.hookBeforeReturnPrepareDataSubmission(item, this.requestData), this.refreshContent.bind(this), this.asyncErrorHandler.bind(this), true);
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	refreshContent(response) {
		response = this.hookBeforeRefreshContent(response);

		let sourceContainer = document.createElement('div');
		sourceContainer.innerHTML = response.dataAsHtml;
		let source = sourceContainer.querySelector(`#${this.requestData.Target}`);
		let target = this.contentContainer.querySelector(`#${this.requestData.Target}`);
		target.innerHTML = source.innerHTML;

		this.firePseudoChangeEvent();
		this.hookAfterRefreshContent(response);
	}

	/**
	 * Change-Event triggern, um asynchrone Change-Operationen auszuführen
	 * @private
	 * @ignore
	 */
	firePseudoChangeEvent() {
		let triggerEvent = new Event('change');
		document.querySelector('.content').dispatchEvent(triggerEvent);
	}
}